import * as React from "react";

import i18next from "i18next";

import { useGetHermesOrdersMissingMappingCount } from "api/reactQuery/queryComponents";
import { USER_ROLES } from "components/Utils/actions";
import ShoppingBag from "svg/ShoppingBag";

import Dropdown from "../Dropdown";
import { Badge, Nav } from "./styles";

const OrdersNavItem = ({
  isVisible,
  userRole,
}: {
  isVisible: boolean;
  userRole: string;
}) => {
  const showPocOrders =
    isVisible && userRole !== USER_ROLES.CUSTOMER_SERVICE;

  const { data: missingMappingCount } =
    useGetHermesOrdersMissingMappingCount({}, { enabled: showPocOrders });

  if (!isVisible) {
    return null;
  }

  return (
    <Nav.Item>
      {showPocOrders && (
        <Badge>
          {missingMappingCount === undefined ? (
            <div className="loader" />
          ) : (
            <Badge
              style={{
                backgroundColor: "#1976d2",
                padding: "3px",
              }}
            >
              {missingMappingCount}
            </Badge>
          )}
        </Badge>
      )}
      <Dropdown
        icon={ShoppingBag}
        title={i18next.t("order")}
        items={[
          { label: i18next.t("create"), to: "/create-order" },
          { label: i18next.t("history"), to: "/order-history" },
          {
            label: i18next.t("calendar_management"),
            to: "/calendar-management",
          },
          ...(userRole !== USER_ROLES.CUSTOMER_SERVICE
            ? [
                {
                  label: `${i18next.t("poc_orders")}${missingMappingCount ? ` (${missingMappingCount})` : ""}`,
                  to: "/poc-orders",
                },
              ]
            : []),
        ]}
      />
    </Nav.Item>
  );
};

export default OrdersNavItem;
